import { ScheduleCampaignFormProvider } from './ScheduleCampaignFormProvider';
import { ScheduleCampaignForm } from './ScheduleCampaignForm';
import { ScheduleModal } from './ScheduleModal';

export const ScheduleCampaignModal = () => {
  return (
    <ScheduleCampaignFormProvider>
      <ScheduleModal>
        <ScheduleCampaignForm />
      </ScheduleModal>
    </ScheduleCampaignFormProvider>
  );
};
